import { useMemo } from "react";
import { getPlatform, isMobileUI, isNative } from "@/lib/platform";

/**
 * Платформын мэдээллийг компонентод өгөх hook.
 *
 *   const { isMobile } = usePlatform();
 *
 * Өмнө нь компонент бүр `new URLSearchParams(window.location.search).get("mobileApp")`
 * гэж ГАРААР шалгадаг байсан (4 газар давхардсан). Одоо нэг эх сурвалжаас ирнэ:
 * webview бүрхүүлийн `?mobileApp=1` флаг БОЛОН Capacitor native аль аль нь.
 *
 * ⚠ Утга нь mount дээр нэг удаа тооцогдоно — платформ ажиллагааны явцад
 * өөрчлөгддөггүй (URL флаг нь бүтэн ачаалалтаар л өөрчлөгдөнө).
 */
export const usePlatform = () => {
    return useMemo(
        () => ({
            /** Мобайл UI горим (header/breadcrumb нуух г.м.) */
            isMobile: isMobileUI(),
            /** Native бүрхүүл (iOS/Android) дотор эсэх */
            isNative: isNative(),
            /** "ios" | "android" | "web" */
            platform: getPlatform(),
        }),
        []
    );
};

export default usePlatform;
